import React from 'react';
import { useTranslation } from 'react-i18next';

import './WidgetTeamFooter.scss';

export interface IWidgetTeamFooterProps {
  revealed: boolean;
  teamCode: string;
}

const WidgetTeamFooter: React.FC<IWidgetTeamFooterProps> = ({ revealed, teamCode }) => {
  const { t } = useTranslation();

  const textStyle = revealed ? 'widget-card-footer__text--revealed' : '';
  const teamStyle = revealed ? 'widget-card-footer__team-text--revealed' : '';

  return (
    <div className="widget-card-footer">
      <div className={`widget-card-footer__text ${textStyle}`}>{revealed && t('vs')}</div>
      <div className={`widget-card-footer__team-text ${teamStyle}`}>{revealed && teamCode}</div>
    </div>
  );
};

export default WidgetTeamFooter;
